import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';


import { getSecciones } from '../../../../API/RRHH/Organigrama/Secciones';
import { getPosiciones } from '../../../../API/RRHH/Organigrama/Posiciones';
import { getImagenes, getOrganigrama } from '../../../../API/RRHH/Organigrama/OrganigramaRequest';
import { getOrganigramaCamden } from '../../../../API/RRHH/Organigrama/OrganigramaCamdenRequest';


import Card from '../../../../Base/Components/Card/Card';
import Icon from '../../../../Base/Components/Icon/Icon';
import Loading from '../../../../Base/Components/Loader/Loader';
import AutoCompleteDropdown from '../../../../Base/Components/Form/AutoCompleteDropdown';

import { useParams } from 'react-router-dom';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';

import { descargarImagen } from '../../../../Base/Utils/Funciones/Descargar';

import './OrganigramaScreen.scss';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';

const OrganigramaScreen = ({ Camden, fondo = false, Num, Sec }) => {

  let { Numero, Seccion } = useParams();


  const toast = useRef(null);

  if (Num && Sec) {
    Numero = Num;
    Seccion = Sec;
  }

  const { userAuth } = useContext(AuthContext);

  const [organigramaInfo, setOrganigramaInfo] = useState([]);
  const [organigrama, setOrganigrama] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [posiciones, setPosiciones] = useState([]);
  const [posicionSelected, setPosicionSelected] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [nivel4, setNivel4] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [seccionSelected, setSeccionSelected] = useState(null);
  const [escale, setEscale] = useState(1)

  const [showOcultos, setShowOcultos] = useState(false)

  const [numEmpleados, setNumEmpleados] = useState(0);

  const [topSelected, setTopSelected] = useState(null);

  // const topPosicion = Numero ? Numero : 'J4';
  // const topSeccion = Seccion ? Seccion : '111';
  const topPosicion = Numero ? Numero : 'J4';
  const topSeccion = Seccion ? Seccion : '111';

  const [top, setTop] = useState({
    posicion: topPosicion,
    seccion: topSeccion
  })


  const posicionColor = {
    J4: { background: '#9C27B0', color: '#FFF' }, //PRESIDENTE
    J5: { background: '#9C27B0', color: '#FFF' }, //PRESIDENTE
    G1: { background: '#005B94', color: '#FFF' }, //DIRECTOR
    X: { background: '#005B94', color: '#FFF' }, //DIRECTOR FINANZAS
    H4: { background: '#6E9A43', color: '#FFF' }, //GERENTE
    F8: { background: '#6E9A43', color: '#FFF' }, //JEFE
    18: { background: '#6E9A43', color: '#FFF' }, //CONTADOR GENERAL
    77: { background: '#6E9A43', color: '#FFF' }, //COORDINADOR
    E4: { background: '#6E9A43', color: '#FFF' }, //SUPERVISOR

  }
  const mostrar = ['GERENTE', 'DIRECTOR', 'COORDINADOR', 'CONTADOR GENERAL']

  const createOrganigrama = (comprimir = false) => {
    const up = organigramaInfo.filter((item) => item.idposicion === top.posicion && item.idseccion === top.seccion);
    if (up.length > 0) {
      const children = getChildren(up[0]);
      const a = crearOrganigrama(children);
      setOrganigrama(a);

      if (children.children.length > 0 && comprimir) {
        let hijos = [];
        // children?.forEach((item) => {
        //   hijos = [...item.children.map((item) => item.children), ...hijos];
        // });
        children.children.forEach((item) => {
          hijos = [...item.children.map((item) => item.children), ...hijos];
        });
        setNivel4(hijos)
      }
    }
  };

  const createOrganigramaCamden = (tempo, comprimir = false) => {
    const up = tempo.filter((item) => item.Posicion === 0);
    if (up.length > 0) {
      const children = getChildreCamden(up[0], tempo);
      const a = crearOrganigramaCandem(children);
      setOrganigrama(a);

      if (children.children.length > 0 && comprimir) {
        let hijos = [];

        children.children.forEach((item) => {
          hijos.push(item.children);
          // console.log(item.Cargo);
          if (item.children.length > 0) {
            // hijos.push(...item.children.map((item) => item.children));
            (item.children?.forEach(element => {



              if (element.Cargo !== 'Gerente') {
                console.log(element);
                // hijos.push([element]);
              } else {
                // console.log(element.Cargo);

              }
            }
            ))
          }
        });
        console.log(hijos);
        setNivel4(hijos)
      }
    }
  };

  const excluidos = []
  // const excluidos = ['-71', '-32', '-58', '-90', '-13', '-12', '-55', '-41', '-105', '-25', '-40', '-35', '-42', '-39', '-103', '-33', '-66', '-47', '-69', '-64','-65']
  // const excluidos = ['-105','-25', '-40', '-71', '-66', '-69', '-64','-65', '-13', '-32','-58', '-105','-25','-71','-23', '-73', '-29', '-56', '-28', '-101', '-28', '-114', '-98']



  const getChildren = (persona) => {
    try {
      const tempoO = organigramaInfo.filter((item) => !excluidos.includes(item.idpersonal))
      // const hijos = tempoO.filter((item) => item.Superior === persona.idposicion && (item.SeccionSuperior !== null ? item.SeccionSuperior === persona.idseccion : item.idseccion === persona.idseccion) );
      const hijos = organigramaInfo.filter((item) => item.Superior === persona.idposicion && (item.SeccionSuperior !== null ? item.SeccionSuperior === persona.idseccion : item.idseccion === persona.idseccion))

      // const hijos = organigramaInfo.filter((item) => item.Superior === persona.idposicion && (item.SeccionSuperior !== null ? item.SeccionSuperior === persona.idseccion : item.idseccion === persona.idseccion) && mostrar.includes(item.Posicion));
      const hijosData = hijos.map((item) => (getChildren(item)));
      const numEmpleados = hijos.filter((item) => item.idpersonal > 0).length;

      // numero de empleados de los hijos
      const numEmpleadosHijos = hijosData.reduce((a, b) => a + b.numEmpleados, 0);

      if (persona?.idpersonal < 2 && hijosData.length === 0 && persona?.Posicion?.includes('GRUPO')) {
        if (!showOcultos) {
          return {}
        }
      }
      return {
        ...persona,
        children: hijosData,
        numEmpleados: numEmpleados + numEmpleadosHijos
      }
    } catch (error) {
      console.log(`Persona: ${persona.idpersonal}`)
      console.log(`Persona: ${persona.idpersonal} error: ${error}`)
      return {
        ...persona,
        children: [],
        numEmpleados: 0
      }
    }

  }

  const getChildreCamden = (persona, tempo) => {
    const hijos = tempo.filter((item) => persona.idpersonal === item.Posicion);
    const hijosData = hijos.map((item) => (getChildreCamden(item, tempo)));
    return {
      ...persona,
      children: hijosData
    }
  }



  const crearOrganigrama = (persona) => {
    if (persona?.idpersonal) {
      let className = '';
      if (persona.Superior === 'J4' && persona.children.length === 0) {
        // className += ' flotante';
      }
      if (persona.idposicion.includes('AU')) {
        className += ' vacio';
      } else {
        className += ' ocupado';
      }
      setLoading(false);
      const classVentasAfter = ['-80'].includes(persona.idpersonal) ? 'vacanteVentasIternacionalesAfter' : '';
      const classVentasBefore = ['-79'].includes(persona.idpersonal) ? 'vacanteVentasIternacionalesBefore' : '';
      const mroh = ['06832'].includes(persona.idpersonal) ? 'mroh' : '';
      const nivelVentas = ['-122'].includes(persona.idpersonal) ? ' NIVEL2 ' : '';
      const nivel2 = ['03951', '02755', '01233', '00557'].includes(persona.idpersonal) ? ' NIV2 ' : '';

      return (<li className={'liContainer ' + persona.Seccion + className + ' ' + persona.Posicion + ' ' + nivelVentas + ' ' + mroh} id={persona.idpersonal} >
        {cardPersona(persona)}
        {/* {persona.children.length > 0 ? <ul id={'hijos' + persona.idpersonal} className={(persona.children.some((i) => i.idposicion.includes('AU')) ? 'AUContainer' : '') + ' ' + nivelVentas + (persona.idpersonal === '-80' ? ' vacanteVentasIternacionales' : '' + persona.children.length % 2 > 0 ? 'ssss' : ' ')}> */}
        {persona.children.length > 0 ? <ul id={'hijos' + persona.idpersonal} className={nivel2 + nivelVentas + (persona.idpersonal === '-80' ? ' vacanteVentasIternacionales' : '' + persona.children.length % 2 > 0 ? 'ssss' : ' ')}>
          {findAux(persona)}
        </ul> : null}
      </li>)
    }
  };


  const crearOrganigramaCandem = (persona) => {
    let className = ` ${persona?.Nivel !== null ? 'NIVEL' + persona.Nivel : '  '} `;
    setLoading(false);
    if (persona.Departamento.includes('GRUPO')) {
      className += ' GRUPO';
    } else {
      className += ' ocupado';
    }
    return (<li className={persona.Seccion + className + ' ' + persona.Posicion} id={persona.idpersonal} >
      {cardPersonaCamden(persona)}
      {persona.children.length > 0 ? <ul id={'hijos' + persona.idpersonal} style={persona.Departamento === 'GRUPO' ? { paddingTop: 0 } : {}} >
        {findAuxCandem(persona)}
      </ul> : null}
    </li>
    )
  }




  const findAux = (persona) => {
    if (!persona?.children.some((i) => i?.idposicion?.includes('AU'))) {
      return persona.children.map((item) => crearOrganigrama(item));
    } else {
      let a = []
      const mitad = Math.ceil(persona.children.length / 2);
      for (let i = 1; i < persona.children.length; i++) {
        if (i !== mitad) {
          a.push(crearOrganigrama(persona.children[i]));
        } else {
          a.push(crearOrganigrama(persona.children[0]));
          a.push(crearOrganigrama(persona.children[i]));
        }
      }
      return a;
    }
  }

  const findAuxCandem = (persona) => {
    if (!persona.children.some((i) => i.Departamento.includes('AUX'))) {
      return persona.children.map((item) => crearOrganigramaCandem(item));
    } else {
      let a = []
      const mitad = Math.ceil(persona.children.length / 2);
      for (let i = 1; i < persona.children.length; i++) {
        if (i !== mitad) {
          a.push(crearOrganigramaCandem(persona.children[i]));
        } else {
          a.push(crearOrganigramaCandem(persona.children[0]));
          a.push(crearOrganigramaCandem(persona.children[i]));
        }
      }
      return a;
    }
  }

  const cardPersonaCamden = (persona) => {
    if (persona?.Departamento.includes('GRUPO')) {
      if (persona.Nivel === 0) {
        return (<div className=' hover' style={{ background: '#F5F5F5', color: '#000' }} onDoubleClick={() => toggleHijos(persona.idpersonal)} >
          {/* {userAuth.IdRol === 1 && <div id={persona.idpersonal + 'card'} className='cardButton'>
            <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.NombreEmpleado}</div>
            <div style={{ fontSize: '12px', fontWeight: '800' }}>{persona.Posicion}</div>
          </div>} */}
        </div>);
      }
      if (persona.Nivel === 1) {
        return (<div className={'GRUPOCard hover'} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
          <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
            {/* {userAuth.IdRol === 1 &&   <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
            {/* <Icon icon='pi-chevron-up' /> */}
          </div>
        </div>);
      }
      if (persona.Nivel === 2) {
        return (<div className={'GRUPOCard hover NIVEL3'} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
          <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
            {/* {userAuth.IdRol === 1 && <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
            <Icon icon='pi-chevron-up' />
          </div>
        </div>);
      }
      return (<div className={'GRUPOCard hover ' + (persona?.Nivel?.includes('NIVEL2') ? 'NIVEL2' : '')} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
        <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
          {/* {userAuth.IdRol === 1 && <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
          <Icon icon='pi-chevron-up' />
        </div>
      </div>);
    }


    return (
      <div className={`persona hover Nivel${persona.Nivel} ${persona.children.length === 1 ? 'unHijo' : 0} ${persona?.Planilla}`} onDoubleClick={() => toggleHijos(persona.idpersonal)} onClick={() => changeColor(persona.idpersonal)} style={{ width: 200, paddingTop: 20, height: Camden ? 250 : 200 }}>
        <div className='bloqueDecoracion' style={{ ...posicionColor[persona.idposicion], backgroundColor: '#6E9A43' }}>
          <span style={{ fontSize: 14 }} >{persona.Cargo}</span>
        </div>

        <div className="personaCard">
          {/* <img src="https://were.ppf.com.hn/web/Logo512.png" alt="" className='fondo' /> */}
          <img src='https://cdn-icons-png.flaticon.com/512/25/25634.png' alt='Grupo' style={{ borderRadius: '0px !important' }} />
          <strong style={{ fontSize: 14 }}>{persona?.Nombre}</strong>
          <strong className='seccion' style={{ fontSize: 14 }}>{persona?.Departamento}</strong>
          <span className='seccion' style={{ fontSize: 14 }} >{persona?.Planilla}</span>
          <span className='seccion' style={{ fontSize: 14 }} > Plazas: {persona.Cantidad}</span>
          {persona.PorTurno > 0 && <span className='seccion' style={{ fontSize: 14 }} > Por Turno: {persona?.PorTurno}</span>}
          {/* <span>{persona.idpersonal > 0 ? persona.idpersonal : ''}</span> */}
          {/* <span>{persona['Por Turno']}</span> */}
          <strong>{persona.Tipo}</strong>
          <strong style={{ color: 'green', fontWeight: '600' }}>{persona?.numEmpleados && persona?.numEmpleados > 0 ? ' Colaboradores: ' + (persona?.numEmpleados + 1) : ''}</strong>
        </div>

      </div>
    );
  }


  const cardPersona = (persona) => {
    // if (persona?.idposicion?.includes('AU')) {
    //   return (<div className='AU hover' onDoubleClick={() => toggleHijos(persona.idpersonal)} >
    //     <div id={persona.idpersonal + 'AU'} className='AUButton'>
    //       {/* {userAuth.IdRol === 1 && <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal}, {persona.idposicion}</div>} */}
    //       {/* <Icon icon='pi-chevron-up' /> */}
    //     </div>
    //   </div>);
    // }
    if (persona?.Posicion.includes('GRUPO')) {
      if (persona.Posicion.includes('NIVEL0')) {
        return (<div className=' hover' style={{ background: '#F5F5F5', color: '#000' }} onDoubleClick={() => toggleHijos(persona.idpersonal)} >
          {/* {userAuth.IdRol === 1 && <div id={persona.idpersonal + 'card'} className='cardButton'>
            <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.NombreEmpleado}</div>
            <div style={{ fontSize: '12px', fontWeight: '800' }}>{persona.Posicion}</div>
          </div>} */}
        </div>);
      }
      if (persona.Posicion.includes('NIVEL1')) {
        return (<div className={'GRUPOCard hover NIVEL1'} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
          <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
            {/* {userAuth.IdRol === 1 &&   <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
            <Icon icon='pi-chevron-up' />
          </div>
        </div>);
      }
      if (persona.Posicion.includes('NIVEL3')) {
        return (<div className={'GRUPOCard hover NIVEL3'} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
          <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
            {/* {userAuth.IdRol === 1 && <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
            <Icon icon='pi-chevron-up' />
          </div>
        </div>);
      }
      return (<div className={'GRUPOCard hover ' + (persona?.Posicion.includes('NIVEL2') ? 'NIVEL2' : '')} onDoubleClick={() => toggleHijos(persona?.idpersonal)} >
        <div id={persona?.idpersonal + 'GRUPO'} className='AUButton'>
          {/* {userAuth.IdRol === 1 && <div style={{ fontSize: '14px', fontWeight: '800' }}>{persona.idpersonal},{persona.Cuenta}, {persona.idposicion}</div>} */}
          <Icon icon='pi-chevron-up' />
        </div>
      </div>);
    }

    const imagen = imagenes.find((item) => item.idpersonal === persona.idpersonal); let posicion = persona.Posicion;
    let seccion = persona.Seccion;
    let idposicion = persona.idposicion;
    let nivel = ''
    switch (persona?.idpersonal) {
      case '06831':
        seccion = 'ASISTENTE PRESIDENTE';
        break;
      case '-1':
        posicion = 'FINANZAS ADMINISTRACION';
        seccion = 'V.P. FINANZAS ADMINISTRACION Y DIRECTOR FINANCIERO'
        break;
      case '06580':
        posicion = 'PLANTA';
        seccion = 'V.P. PLANTA Y DIRECTOR TEXTIL'
        break;
      case '03805':
        posicion = 'VENTAS';
        seccion = 'V.P. VENTAS Y DIRECTOR DE MARKETING'
        break;
      // case '01233':
      //   posicion = 'GERENTE SERVICIO AL CLIENTE';
      //   idposicion = 'H4'
      //   seccion = 'SERVICIO AL CLIENTE'
      //   break;
      // case '00557':
      //   posicion = 'GERENTE SERVICIO AL CLIENTE';
      //   idposicion = 'H4'
      //   seccion = 'SERVICIO AL CLIENTE'
      //   break;
      // case '03951':
      //   posicion = 'GERENTE DE VENTAS';
      //   idposicion = 'H4'
      //   seccion = 'NUEVO MERCADO'
      //   break;
      // case '02755':
      //   posicion = 'GERENTE DE VENTAS';
      //   idposicion = 'H4'
      //   seccion = 'NUEVAS TELAS CON CLIENTES ACTUALES'
      //   break;
      // case '05298':
      //   posicion = 'SENIOR GERENTE ';
      //   seccion = 'SERVICIO AL CLIENTE'
      //   idposicion = 'H4'
      //   break;
      case '-79':
        idposicion = 'H4'
        break;
      case '-122':
        nivel = 'Nivel2'
        break;
      default:
        break;
    }
    let NombreEmpleado = persona.NombreEmpleado;
    let IdPersonal = persona.idpersonal;
    if (['07026'].includes(persona.idpersonal)) {
      // NombreEmpleado = 'AUXILIAR DE VENTAS';
      // IdPersonal = ''
      // seccion = 'AUXILIAR DE VENTAS'
      nivel = 'Nivel2'
    }
    // if(['07025','06815', '05554', '07026'].includes(persona.idpersonal)){
    // //   NombreEmpleado = 'SERVICIO AL CLIENTE';
    // //   IdPersonal = ''
    //   seccion = 'SERVICIO AL CLIENTE'
    // //   nivel = 'Nivel2'
    // }

    return (
      <div className={'persona hover ' + nivel} onDoubleClick={() => toggleHijos(persona.idpersonal)} onClick={() => changeColor(persona.idpersonal)}>
        <div className='bloqueDecoracion' style={posicionColor[idposicion]}>
          <span >{posicion}</span>
        </div>

        <div className="personaCard">
          {/* <img src="https://were.ppf.com.hn/web/Logo512.png" alt="" className='fondo' /> */}
          {persona.Posicion === 'GRUPO' || !imagen?.img ?
            <img src='https://cdn-icons-png.flaticon.com/512/25/25634.png' alt='Grupo' style={{ borderRadius: '0px !important' }} />
            :
            <img className='photo' src={'data:image/png;base64,' + imagen?.img} alt={''} width={'50px'} />}
          <strong >{NombreEmpleado}</strong>
          <span className='seccion' >{seccion}</span>
          <span>{persona.idpersonal > 100 ? IdPersonal : ''}</span>
          <span>{persona.Cuenta}</span>
          <strong style={{ color: 'green', fontWeight: '600' }}>{persona?.numEmpleados && persona?.numEmpleados > 0 ? ' Colaboradores: ' + (persona?.numEmpleados + 1) : ''}</strong>





        </div>

      </div>
    );
  }





  // EVENTOS DE LOS BOTONES
  // OCULTAR O MOSTRAR HIJOS
  const toggleHijos = (id) => {
    const hijos = document.getElementById('hijos' + id);
    const AU = document.getElementById(id + 'AU');
    if (hijos) {
      hijos.classList.toggle('hide');
    }
    if (AU) {
      AU.classList.toggle('rotate');
    }
  }

  // CAMBIAR DE COLOR CARD PERSONA
  const changeColor = (id) => {
    const selected = document.getElementsByClassName('selected');
    if (selected.length > 0) {
      if (selected[0].id !== id) {
        selected[0].classList.remove('selected');
      }
    }
    const hijos = document.getElementById(id);
    if (hijos) {
      hijos.classList.toggle('selected');
    }
  }

  const comprimir = () => {
    if (Camden) {
      createOrganigramaCamden(organigramaInfo, true);
    } else {
      createOrganigrama(true);
    }
  }


  const getInfo = async () => {
    if (!Camden) {
      setLoading(true);
      let tempo = await getOrganigrama();
      console.log(tempo);
      tempo = tempo.map((i) => {
        return {
          ...i,
          CodigoNombre: i?.idpersonal + ' - ' + i?.NombreEmpleado
        }
      })

      const getColabores = (persona) => {
        const hijos = tempo?.filter((item) => item.Superior === persona.idposicion && (item.SeccionSuperior !== null ? item.SeccionSuperior === persona.idseccion : item.idseccion === persona.idseccion));
        if (hijos.length > 0) {
          let desc = [];
          hijos.forEach((h) => {
            // console.log(h);
            try {
              desc = [...desc, ...getColabores(h)]

            } catch (error) {
              toastShow(toast, 'error', `Error al obtener colaboradores de ${h.NombreEmpleado} (${h.idpersonal})`, 5000);
              desc = [];
            }
          })
          return [persona, ...desc].filter(e => e !== 0)
        } else {
          return [persona]
        }
      }

      const cabeza = tempo?.filter(p => p.idposicion === topPosicion && p.idseccion === topSeccion)
      if (cabeza.length > 0) {
        const a = getColabores(cabeza[0])
        setOrganigramaInfo(a);
        setEmpleados(a);
        const img = await getImagenes(a.map((item) => item.idpersonal));
        setImagenes(img);
      }






      // setOrganigramaInfo(tempo);
      // setEmpleados(tempo);
      const posi = await getPosiciones();
      const secc = await getSecciones();
      setSecciones(secc);

      let empleados = 0;
      tempo.forEach((item) => {
        if (item.idpersonal > 0) {
          empleados++;
        }
      });

      setNumEmpleados(empleados);

      let posiTemp = []
      posi.forEach((item) => {
        if (tempo.some((p) => p.idposicion === item.CodigoPosicion)) {
          posiTemp.push(item);
        }
      });

      setPosiciones(posiTemp);
    } else {
      setLoading(true);
      const tempo = await getOrganigramaCamden();
      setOrganigramaInfo(tempo);
      setEmpleados(tempo);
      createOrganigramaCamden(tempo);
    }
  }

  const changeScale = (option) => {
    const rango = 0.1

    if (option === 1) { // SUBIR LA ESCALA
      setEscale(escale + rango)
      return
    }

    if (option === -1) { // BAJAR LA ESCALA
      setEscale(escale - rango)
      return
    }

    setEscale(1)

  }


  useEffect(() => {
    setLoading(true);
    getInfo();
    window.document.title = 'PPF • Organigrama';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Camden])


  useEffect(() => {
    if (typeof topSelected !== 'string') {
      if (topSelected) {
        setTop({
          posicion: topSelected.idposicion,
          seccion: topSelected.idseccion,
        })
      } else {
        setTop({
          posicion: topPosicion,
          seccion: topSeccion,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topSelected])

  useEffect(() => {
    setEmpleados([]);
    setTopSelected(null);
    if (typeof posicionSelected !== 'string') {
      if (posicionSelected) {
        const personas = organigramaInfo.filter((item) => (item.idposicion + '') === (posicionSelected.CodigoPosicion + ''));
        setEmpleados(personas);
        if (personas.length === 1) {
          console.log(personas[0]);
          setTopSelected(personas[0]);
        }
      } else {
        const personas = organigramaInfo.filter((item) => (item.idposicion + '') === (topPosicion + ''));
        setEmpleados(personas);
        setTopSelected(personas[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posicionSelected])


  useEffect(() => {
    setEmpleados([]);
    setTopSelected(null);
    if (typeof seccionSelected !== 'string') {
      if (seccionSelected) {
        const personas = organigramaInfo.filter((item) => (item.idseccion + '') === (seccionSelected.CodigoSeccion + ''));
        setEmpleados(personas);
        if (personas.length === 1) {
          setTopSelected(personas[0]);
        }
      } else {
        const personas = organigramaInfo.filter((item) => (item.idseccion + '') === (topSeccion + ''));
        setEmpleados(personas);
        setTopSelected(personas[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seccionSelected])


  useEffect(() => {
    if (!Camden) {
      createOrganigrama();
    } else {

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagenes, top, showOcultos])




  useEffect(() => {
    if (nivel4.length > 0) {
      nivel4.forEach((item) => {
        item?.forEach((i) => {
          const a = document.getElementById('hijos' + i.idpersonal);
          if (a) {
            a.classList.toggle('hide');
          }
        })
      })
    }
  }, [nivel4])


  return (
    <div className='organigramaContainer' style={{ height: '100vh' }}>
      <Toast ref={toast} position="top-right" />



      {/* <div className="treeOrganigrama" style={{ height: '100%', background: Seccion && !fondo ? 'transparent' : '#0d354e', overflow: Seccion ? 'scroll' : 'auto' }}> */}
      <div className={`treeOrganigrama ${Camden ? 'organigramaCamden' : ''}`} style={{ background: Seccion && !fondo ? 'transparent' : '#0d354e' }}>
        {/* <div className="treeOrganigrama" > */}
        <Loading loading={loading} querySelector={'.treeOrganigrama'} />
        {!Camden && <div className={classNames('p-2 align-items-end', { 'isNotVisible': Seccion, 'd-flex': !Seccion })} style={{ position: 'sticky' }} >

          {!Numero && !Seccion && <Card
            className='col-12 justify-content-end'
            style={{ backgroundColor: 'transparent', borderColor: 'white', padding: 5, color: 'gray' }}
            styleTitle={{ backgroundColor: '#0d354e', color: 'white' }}
            titulo={<h3>Filtros</h3>}
            contenido={<div className='d-flex col-12'>
              <div className={'col-2 px-2 '}>
                <AutoCompleteDropdown
                  value={seccionSelected}
                  onValueChange={(e) => setSeccionSelected(e.value)}
                  items={secciones}
                  field={'Seccion'}
                  Name={'Departamento'}
                  label={'Departamento'}
                  // placeholder={'Buscar por sección'}
                  habilitar={posicionSelected !== null}
                  labelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                />
              </div>
              <div className={'col-2 px-2'}>
                <AutoCompleteDropdown
                  value={posicionSelected}
                  onValueChange={(e) => setPosicionSelected(e.value)}
                  items={posiciones}
                  field={'Posicion'}
                  // placeholder={'Buscar por posición'}
                  label={'Posición'}
                  habilitar={seccionSelected !== null}
                  labelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                />
              </div>

              <div className={'col-3 px-2'}>
                <AutoCompleteDropdown
                  value={topSelected}
                  onValueChange={(e) => setTopSelected(e.value)}
                  items={empleados}
                  field={'CodigoNombre'}
                  placeholder={'Buscar por nombre'}
                  label={'Nombre'}
                  labelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                // habilitar={!posicionSelected}
                />
              </div>

              <div className={' px-2 d-flex align-items-end'}>
                <Button className='mx-2' label='Comprimir' onClick={comprimir} />
                {/* {JSON.stringify(user, null, 3)} */}
                {
                  <Button className='mx-2' icon='pi pi-print'
                    onClick={e => descargarImagen('liContainer', 'Organigrama')}
                  //  onClick={event => window.open(`${process.env.REACT_APP_ENV}/RRHH/Organigrama/print/${top.posicion}/${top.seccion}`, "MsgWindow", 'height=1200,width=1000')} 
                  />}
                {/* TOGGLE OCULTOS */}
                {userAuth?.IdRol === 1 && <Button className='mx-2' label={showOcultos ? 'Ocultar' : 'Mostrar'} onClick={() => setShowOcultos(!showOcultos)} />}

                <div className='float d-flex gap'>
                  <Button icon='pi pi-search-plus' onClick={e => changeScale(1)} />
                  <Button icon='pi pi-search-minus' onClick={e => changeScale(-1)} />
                  <Button icon='pi pi-refresh' onClick={e => changeScale(0)} />
                  <div>
                    Escala: {escale}
                  </div>
                </div>
                <div className={'d-flex align-items-center justify-content-center'} style={{ height: '75%', }}>
                  <div style={{ color: 'white', verticalAlign: 'middle' }}  >
                    Empleados: {numEmpleados}
                  </div>
                </div>


              </div>
            </div>}
          />}

        </div>}
        <div id='diagrama' className={`diagrama`} style={{ overflow: 'scroll', paddingBottom: 30,  }}>
          {Camden && <div>
            <Button className='mx-2 Comprimir' size='3' icon={'pi pi-angle-double-up'} onClick={comprimir} />
          </div>}
          <ul id='diagrama-ul' className='col-12' style={{transformOrigin: "top left", transform: `scale(${escale})` }} >
            {organigrama}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OrganigramaScreen;
